import React, { useState } from 'react';
import {useNavigate} from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpRight, Maximize2 } from 'lucide-react';
import livingRoom from "../../assets/projects/purwanchal-noida/2.jpeg";

import office1 from "../../assets/projects/office-1.jpeg";
import retail1 from "../../assets/projects/retail-1.jpeg";
// import penthouse from "../../assets/projects/retail-1.jpeg";
import penthouse from "../../assets/projects/before-after/after1.jpg";
// import office2 from "../../assets/projects/office-2.jpeg";
import office2 from "../../assets/projects/purwanchal-noida/3.jpeg";
import restaurant from "../../assets/projects/restaurant-1.jpeg";

const categories = ['All', 'Residential', 'Commercial', 'Office'];

const projects = [
  {
    id: 1,
    title: 'Serene Living Space',
    category: 'Residential',
    image: livingRoom,
    size: 'large',
  },
  {
    id: 2,
    title: 'Modern Corporate Hub',
    category: 'Office',
    image: office1,
    size: 'small',
  },
  {
    id: 3,
    title: 'Boutique Retail Store',
    category: 'Commercial',
    image: retail1,
    size: 'small',
  },
  {
    id: 4,
    title: 'Luxury Residential house',
    category: 'Residential',
    image: penthouse,
    size: 'medium',
  },
  {
    id: 5,
    title: 'Puja Room Design',
    category: 'Puja Room',
    image: office2,
    size: 'medium',
  },
  {
    id: 6,
    title: 'Hall Room',
    category: 'Commercial',
    image: restaurant,
    size: 'large',
  },
];

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredProjects = activeCategory === 'All' 
    ? projects 
    : projects.filter(p => p.category === activeCategory);

    const navigate = useNavigate();

  return (
    
    <section id="portfolio" className="py-24 md:py-32 bg-[#2C2C2C]">
      <div className="max-w-7xl mx-auto px-6 md:px-16">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-[1px] bg-[#C9A962]" />
            <span className="text-[#C9A962] tracking-[0.3em] text-xs uppercase">Our Work</span>
            <div className="w-12 h-[1px] bg-[#C9A962]" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-4">
            Featured Projects
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-lg">
            Explore our portfolio of transformative interior design projects across various segments.
          </p>
        </motion.div>

        {/* Category Filter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex justify-center gap-2 mb-12"
        >
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-2 text-sm tracking-wide transition-all ${
                activeCategory === category
                  ? 'bg-[#C9A962] text-white'
                  : 'bg-white/5 text-white/60 hover:text-white hover:bg-white/10'
              }`}
            >
              {category}
            </button>
          ))}
        </motion.div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <AnimatePresence mode="wait">
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ delay: index * 0.1 }}
                className={`group relative overflow-hidden cursor-pointer ${
                  project.size === 'large' ? 'md:col-span-2 md:row-span-2' : ''
                } ${project.size === 'medium' ? 'md:row-span-2' : ''}`}
              >
                <div className={`relative ${project.size === 'large' ? 'h-[500px]' : project.size === 'medium' ? 'h-[500px]' : 'h-60'}`}>
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2C2C2C] via-transparent to-transparent opacity-60 group-hover:opacity-90 transition-opacity" />
                  
                  {/* Content */}
                  <div className="absolute inset-0 p-6 flex flex-col justify-end">
                    <span className="text-[#C9A962] text-xs tracking-widest uppercase mb-2">
                      {project.category}
                    </span>
                    <h3 className="font-serif text-xl md:text-2xl text-white mb-4">
                      {project.title}
                    </h3>
                    
                    <div className="flex items-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity translate-y-4 group-hover:translate-y-0">
                      <button className="w-10 h-10 bg-[#C9A962] flex items-center justify-center hover:bg-[#b8954f] transition-colors">
                        <ArrowUpRight className="w-4 h-4 text-white" />
                      </button>
                      <button className="w-10 h-10 bg-white/20 backdrop-blur flex items-center justify-center hover:bg-white/30 transition-colors">
                        <Maximize2 className="w-4 h-4 text-white" />
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>

        {/* View All Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12 "
        >
          <button
          onClick={() => navigate("/portfolio")}
          className="inline-flex items-center text-white border border-white/30 px-8 py-4 hover:bg-white hover:text-[#2C2C2C] transition-all group"
        >
          View All Projects
          <ArrowUpRight className="ml-2 w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
        </button>
        </motion.div>
      </div>
    </section>
  );
}